<template>
    <div class="form-elements">
        <div class="row">
            <div class="col-md-12">
                <vuestic-widget headerText="Alunos">
                  <FormAluno></FormAluno>
                </vuestic-widget>
            </div>
        </div>
    </div>
</template>

<script>
import FormAluno from './FormAluno'
export default {
  name: 'form-aluno-cadastro',
  components: {
    FormAluno
  }
}
</script>
